import { useEffect, useState } from "react";
import { usePerTierKycOffering } from "./usePerTierKycOffering";
import {
  PER_TIER_KYC_FIELD_KEYS,
} from "./PerTierKyc.constants";
import {
  PAGE_SECTIONS_KEYS,
} from "features/ManageOfferings/modules/OfferingPageSections/constants/OfferingPageSectionsKeys.constants";
import { getKeyLevelSettings } from "features/AdminPanel/modules/utils/AdminPanel.utils";

const readCreatorFlag = (settings, key) => {
  const root = settings?.data ?? settings ?? {};
  const map = root?.data ?? root;
  return map?.[key]?.value ?? false;
};

/**
 * Whether KYC is enabled at the offering (parent) level.
 * Mirrors checkout resolution (creator default -> listing override): the tier
 * KYC columns/options render when either level enables esign or KRA.
 */
export const useOfferingKycEnabled = ({ listingUuid } = {}) => {
  const { fetchOfferingKyc } = usePerTierKycOffering();
  const [isKycEnabled, setIsKycEnabled] = useState(false);

  useEffect(() => {
    if (!listingUuid) return;
    let cancelled = false;
    Promise.all([
      fetchOfferingKyc({ listingUuid }),
      getKeyLevelSettings([
        PAGE_SECTIONS_KEYS.IS_ESIGN_ENABLED,
        PAGE_SECTIONS_KEYS.IS_DIGIO_KYC_ENABLED,
      ]).catch(() => null),
    ]).then(([offering, creatorSettings]) => {
      if (cancelled) return;
      setIsKycEnabled(
        Boolean(
          offering?.[PER_TIER_KYC_FIELD_KEYS.IS_ESIGN_ENABLED] ||
            offering?.[PER_TIER_KYC_FIELD_KEYS.IS_DIGIO_KYC_ENABLED] ||
            readCreatorFlag(
              creatorSettings,
              PAGE_SECTIONS_KEYS.IS_ESIGN_ENABLED
            ) ||
            readCreatorFlag(
              creatorSettings,
              PAGE_SECTIONS_KEYS.IS_DIGIO_KYC_ENABLED
            )
        )
      );
    });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listingUuid]);

  return { isKycEnabled };
};
